module.exports = __webpack_public_path__ + "static/media/copper-pipe.518dc793.png";